const install = (Vue, vm) => {
    Vue.prototype.$d = {
        listWebPageConfig: (params = {}) => vm.$api.post('/webPage/listWebPageConfig', params),


        getMenuZf: (params = {}) => vm.$api.post('/home/getMeunZf', params),
        getMenuQy: (params = {}) => vm.$api.post('/home/getMeun', params),
        getMenu: (params = {}) => vm.$api.post('/home/getMeun', params),
        loginZf: (params = {}) => vm.$api.post('/login/loginZf', params),
        loginQy: (params = {}) => vm.$api.post('/login/loginQy', params),

        //企业

        listCorp: (params = {}) => vm.$api.post('/corp/listCorp', params),
        listCorpCert: (params = {}) => vm.$api.post('/corp/listCorpCert', params),
        addCorp: (params = {}) => vm.$api.post('/corp/addCorp', params),
        selectCorpById: (params = {}) => vm.$api.post('/corp/selectCorpById', params),
        updateCorp: (params = {}) => vm.$api.post('/corp/updateCorp', params),
        verifyCorp: (params = {}) => vm.$api.post('/corp/verify', params),

        //人员

        listPerson: (params = {}) => vm.$api.post('/person/listPerson', params),
        selectPersonById: (params = {}) => vm.$api.post('/person/selectPersonById', params),
        addPerson: (params = {}) => vm.$api.post('/person/addPerson', params),
        updatePerson: (params = {}) => vm.$api.post('/person/updatePerson', params),
        verifyPerson: (params = {}) => vm.$api.post('/person/verify', params),

        //工程

        selectProjectById: (params = {}) => vm.$api.post('/project/selectProjectById', params),
        listProject: (params = {}) => vm.$api.post('/project/listProject', params),
        addProject: (params = {}) => vm.$api.post('/project/addProject', params),
        updateProject: (params = {}) => vm.$api.post('/project/updateProject', params),
        verifyProject: (params = {}) => vm.$api.post('/project/verify', params),

        //起重机械
        listSbBa: (params = {}) => vm.$api.post('/hoimac/listSbBa', params),
        selectSbBaById: (params = {}) => vm.$api.post('/hoimac/selectSbBaById', params),
        addSbBa: (params = {}) => vm.$api.post('/hoimac/addSbBa', params),
        updateSbBa: (params = {}) => vm.$api.post('/hoimac/updateSbBa', params),
        revokeSbBa: (params = {}) => vm.$api.post('/hoimac/revokeSbBa', params),
        examineSbBa: (params = {}) => vm.$api.post('/hoimac/examineSbBa', params),

        //设备使用记录列表
        listReportSbsy: (params = {}) => vm.$api.post('/hoimac/listReportSbsy', params),
        addInstallInform: (params = {}) => vm.$api.post('/hoimac/addInstallInform', params),
        editInstallInform: (params = {}) => vm.$api.post('/hoimac/editInstallInform', params),
        editUseRegInform: (params = {}) => vm.$api.post('/hoimac/editUseRegInform', params),
        addUseRegInform: (params = {}) => vm.$api.post('/hoimac/addUseRegInform', params),
        editUseRegInform: (params = {}) => vm.$api.post('/hoimac/editUseRegInform', params),
        addUnInstallInform: (params = {}) => vm.$api.post('/hoimac/addUnInstallInform', params),
        editUnInstallInform: (params = {}) => vm.$api.post('/hoimac/editUnInstallInform', params),
        approveInstallInform: (params = {}) => vm.$api.post('/hoimac/approveInstallInform', params),
        approveUseInform: (params = {}) => vm.$api.post('/hoimac/approveUseInform', params),
        approveUnInstallInform: (params = {}) => vm.$api.post('/hoimac/approveUnInstallInform', params),
        selectInstallInform: (params = {}) => vm.$api.post('/hoimac/selectInstallInform', params),
        selectUseInform: (params = {}) => vm.$api.post('/hoimac/selectUseInform', params),
        selectUnInstallInform: (params = {}) => vm.$api.post('/hoimac/selectUnInstallInform', params),

        //日常工作

        //巡查
        listXcjl: (params = {}) => vm.$api.post('/project/listXcjl', params),
        addXcjl: (params = {}) => vm.$api.post('/project/addXcjl', params),
        selectXcjlById: (params = {}) => vm.$api.post('/project/selectXcjlById', params),
        //验收
        selectYsjlById: (params = {}) => vm.$api.post('/project/selectYsjlById', params),
        listYsjl: (params = {}) => vm.$api.post('/project/listYsjl', params),
        addYsjl: (params = {}) => vm.$api.post('/project/addYsjl', params),
        verifyYsjl: (params = {}) => vm.$api.post('/project/verifyYsjl', params),
        //整改
        selectZgById: (params = {}) => vm.$api.post('/project/selectZgById', params),
        listZg: (params = {}) => vm.$api.post('/project/listZg', params),
        addZg: (params = {}) => vm.$api.post('/project/addZg', params),
        zghf: (params = {}) => vm.$api.post('/project/zghf', params),
        shzghf: (params = {}) => vm.$api.post('/project/shzghf', params),

    };
}

export default {
    install
}
